import { Http } from "@/plugins/http.js";
export const getDocuments = async () => {
  const { data } = await Http.get(`v1/documents/templates`);
  if (data) {
    return data.data;
  }
  return [];
};
export const generateDocument = async data => {
  const res = await Http.get(`v1/documents/generate`, {
    params: {
      template_id: data.template_id,
      entity_type: data.entity_type,
      entity_id: data.entity_id,
    },
    responseType: "blob",
  });

  const aElement = document.createElement("a");
  aElement.setAttribute("download", data.name);
  const href = URL.createObjectURL(res.data);
  aElement.href = href;
  aElement.setAttribute("target", "_blank");
  aElement.click();
  URL.revokeObjectURL(href);
};
